// src/components/NewsFeed.jsx
import { PostBanner } from "./AdminNewsPage";
import { fmtDate } from "../utils/constants";

export default function NewsFeed({ posts, loading, onOpenPost }) {

  return (
    <div>
      <div style={{ marginBottom: 4 }}>
        <div className="toa-slbl">Latest Updates</div>
        <div className="toa-stit">News &amp; Announcements</div>
      </div>
      <div className="toa-sdiv" />

      {loading && (
        <div style={{ color: "var(--muted)", fontSize: 14, padding: "20px 0" }}>Loading news...</div>
      )}
      {!loading && posts.length === 0 && (
        <div style={{ color: "var(--muted)", fontSize: 14, padding: "20px 0" }}>No posts yet. Check back soon!</div>
      )}

      {posts.map(post => {
        const { day, mon } = fmtDate(post.created_at);
        const tags = typeof post.tags === "string" ? JSON.parse(post.tags || "[]") : (post.tags || []);
        return (
          <article
            className="toa-post"
            key={post.id}
            onClick={() => onOpenPost(post.slug)}
            style={{ cursor: "pointer" }}
          >
            <div className="toa-ph">
              <div className="toa-pdate">
                <div className="toa-pday">{day}</div>
                <div className="toa-pmon">{mon}</div>
              </div>
              <div>
                <div className="toa-ptitle">{post.title}</div>
                <div className="toa-pinfo">
                  By <span>{post.author}</span> ·{" "}
                  {new Date(post.created_at).toLocaleDateString("en-GB", {
                    day: "2-digit", month: "short", year: "numeric",
                  })}
                </div>
              </div>
            </div>

            <PostBanner post={post} />

            <div className="toa-pbody">
              {tags.map(tag => <span key={tag} className="toa-tag">{tag}</span>)}
              <p>{post.excerpt}</p>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 6 }}>
                <span style={{
                  fontSize: 11, color: "var(--purpleB)", fontFamily: "'Cinzel',serif",
                  letterSpacing: .5, display: "inline-block",
                }}>
                  Read more →
                </span>
                <button
                  onClick={e => {
                    e.stopPropagation();
                    const url = `${window.location.origin}/news/${post.slug}`;
                    navigator.clipboard.writeText(url).catch(() => {});
                  }}
                  title="Copy link"
                  style={{
                    background: "none", border: "none", cursor: "pointer",
                    color: "var(--muted)", fontSize: 11, fontFamily: "'Cinzel',serif",
                    letterSpacing: .5, display: "flex", alignItems: "center", gap: 5,
                    padding: "2px 6px", borderRadius: 4, transition: ".15s",
                  }}
                  onMouseOver={e => e.currentTarget.style.color = "var(--purpleB)"}
                  onMouseOut={e => e.currentTarget.style.color = "var(--muted)"}
                >
                  🔗 Copy link
                </button>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}